import { endOfDay, startOfDay, subDays } from "date-fns";

export type DatePreset = "any" | "today" | "yesterday" | "last7";

export interface UploadedAtBounds {
  uploadedAfter?: string;
  uploadedBefore?: string;
}

/**
 * Map client day presets to local-day UTC ISO bounds for GET /file/list.
 * Server has no named presets — only `uploaded_after` / `uploaded_before`.
 */
export function datePresetToUploadedBounds(preset: DatePreset, now = new Date()): UploadedAtBounds {
  if (preset === "any") return {};

  if (preset === "today") {
    return {
      uploadedAfter: startOfDay(now).toISOString(),
      uploadedBefore: endOfDay(now).toISOString(),
    };
  }

  if (preset === "yesterday") {
    const day = subDays(now, 1);
    return {
      uploadedAfter: startOfDay(day).toISOString(),
      uploadedBefore: endOfDay(day).toISOString(),
    };
  }

  // Inclusive rolling 7 local calendar days ending today
  return {
    uploadedAfter: startOfDay(subDays(now, 6)).toISOString(),
    uploadedBefore: endOfDay(now).toISOString(),
  };
}
